const featureData = [
  {
    name: "Bags",
    desc: "Premium bags for every occasion",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Luxury%20leather%20tote%20bag%20with%20gold%20hardware%20on%20minimal%20cream%20surface%2C%20soft%20warm%20terracotta%20background%20gradient%2C%20elegant%20product%20photography%2C%20professional%20fashion%20display%2C%20clean%20modern%20composition%2C%20gentle%20studio%20lighting&width=700&height=900&seq=feat-bags-main-01&orientation=portrait"
  },
  {
    name: "Belts",
    desc: "Crafted belts with timeless design",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20with%20brass%20buckle%20coiled%20on%20warm%20sand%20colored%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20luxury%20product%20photography%2C%20clean%20elegant%20display%2C%20modern%20accessory%20catalog%20style&width=700&height=900&seq=feat-belts-main-02&orientation=portrait"
  },
  {
    name: "Perfumes",
    desc: "Signature fragrances for you",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20and%20sage%20green%20eucalyptus%20leaves%20on%20cream%20marble%20surface%2C%20soft%20diffused%20lighting%2C%20luxury%20fragrance%20photography%2C%20modern%20minimalist%20aesthetic%2C%20clean%20composition&width=700&height=900&seq=feat-perfumes-main-03&orientation=portrait"
  },
];

export default function FeatureShowcase() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            Featured <span className="italic text-accent-500">Picks</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featureData.map((item, idx) => (
            <a
              key={item.name}
              href={item.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative rounded-xl overflow-hidden h-[420px] md:h-[480px] transition-all duration-500 hover:scale-[1.02] ${
                idx === 0 ? "md:col-span-1" : ""
              } cursor-pointer`}
            >
              <img
                src={item.image}
                alt={item.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-2xl font-heading font-bold text-white mb-1">
                  {item.name}
                </h3>
                <p className="text-sm text-white/70">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}